module.exports = __webpack_public_path__ + "img/job.3269cc41.svg";